var uiBreakdown = {
	table: {
		caption: "Zusammensetzung",
		weight: "Anteil %",
		name: "Name",
		noItems: "Keine Ergebnisse gefunden"
	},
	chart: {
		counting: "Zusammensetzung",
		topPositions: "Top Positionen",
		others: "Sonstige"
	}
};
var de = {
	uiBreakdown: uiBreakdown
};

export { de as default, uiBreakdown };
